import { IconNameEnum, useModuleBEM } from "@b2bportal/core-themes";
import { CoreFlightsComponent } from "@b2bportal/core-types";
import { useDeviceType } from "@b2bportal/core-utilities";
import { useI18nContext } from "@hopper-b2b/i18n";
import { FlightSearch } from "@tenant/flights";
import {
  Button,
  ButtonTypeEnum,
  Dialog,
  DialogContent,
  Icon,
} from "@tenant/ui";
import styles from "./FlightShopSearch.module.scss";
import { useFlightShopSearch } from "./hooks";
import { useIsExchangeFlow } from "@/utilities/flights/useIsExchangeFlow";

export const FlightShopSearch = ({ routeIndex }: { routeIndex?: number }) => {
  const COMPONENT_KEY = CoreFlightsComponent.FlightShopSearch;

  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);
  const { isDesktopAndUp } = useDeviceType();

  const {
    context: { openMobileSearch, subtext, text },
    handlers: { onClose, handleOnSearch, onSearchClick },
  } = useFlightShopSearch(routeIndex);
  const { t } = useI18nContext();
  const isExchangeFlow = useIsExchangeFlow();

  // Hide search component during exchange flows - users can't change selections
  if (isExchangeFlow) {
    return null;
  }

  return (
    <div className={block}>
      {isDesktopAndUp ? (
        <FlightSearch />
      ) : (
        <div className={cn("search-container")}>
          <button className={cn("search-button")} onClick={onSearchClick}>
            <div className={cn("icon")}>
              <Icon iconName={IconNameEnum.search} />
            </div>
            <div className={cn("content")}>
              <p className={cn("search-button-label")}>{subtext}</p>
              <p className={cn("search-button-value")}>{text}</p>
            </div>
          </button>

          <Dialog open={openMobileSearch} onClose={onClose}>
            <DialogContent
              fullScreen={true}
              title={t("flightSearchPrompt")}
              className={cn("search-dialog-content")}
            >
              <FlightSearch
                className={cn("search")}
                onSearch={handleOnSearch}
                showSearchButton={true}
              />
            </DialogContent>
          </Dialog>
        </div>
      )}
    </div>
  );
};
